import {
	createResource,
	useResource,
	type RouteResourceError,
} from '@atlassian/react-resource-router';
import { RESOURCE_TYPE_PROJECT_NEW_ISSUE_VIEW_LOCK_IN_STATUS } from '../../constants.tsx';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const newIssueViewLockInStatusResource = createResource<any>({
	type: RESOURCE_TYPE_PROJECT_NEW_ISSUE_VIEW_LOCK_IN_STATUS,
	getKey: ({ match }) => match.params.projectKey || '',
	getDataLoader: () =>
		import(
			/* webpackChunkName: "async-resource-project-new-issue-view-lock-in-status-data", jiraSpaEntry: "async-resource-project-new-issue-view-lock-in-status-data" */ './get-data'
		),
	maxAge: Number.MAX_VALUE,
});

export type NewIssueViewLockInStatus = {
	loading: boolean;
	error: RouteResourceError | null;
	newIssueViewLockedIn: boolean | null;
};

export const useNewIssueViewLockInStatus: () => NewIssueViewLockInStatus = () => {
	const { data, loading, error } = useResource(newIssueViewLockInStatusResource);
	return {
		loading,
		error,
		newIssueViewLockedIn: data && data.newIssueViewLockedIn,
	};
};
